import { render, staticRenderFns } from "./PasswordResetPopup.vue?vue&type=template&id=40762076&scoped=true&"
import script from "./PasswordResetPopup.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPopup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPopup.vue?vue&type=style&index=0&id=40762076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40762076",
  null
  
)

export default component.exports